<template>
  <div
    @click="onClick"
    :class="{ left: left }"
    class="z4 close-button pointer">
    <img src="@/assets/icon-close-red.svg" alt="Button: Close">
  </div>
</template>

<script>
export default {

  name: 'BackButton',

  data () {
    return {

    }
  },

  props: ['left', 'onClick']
}
</script>

<style lang="css" scoped>
  .close-button {
    width: 24px;
    height: 24px;
    position: fixed;
    padding: 0.5em;
    top: 0.5em;
    left: 0.5em;
  }
</style>
